export const mantizPlataform = {
  title:
    "MantizOnline es una herramienta de automatización inteligente de procesos de negocios",
  label: "Plataforma Mantiz",
  areas: [
    {
      title: "¿Qué es?",
      img: "mantizPlataform/Mantizflujo.gif",
      description: '<FONT SIZE=4>Potente BPMS, fácil de configurar, con interfaz en ambiente Web-Based, amplia conectividad a bases de datos, procedimientos almacenados, Web services, Data Queues, archivos planos y cualquier sistema empresarial.</font>' ,
      path: "https://google.com",
      disableLink: true,
    },
    {
      title: "Funcionalidades",
      img: "mantizPlataform/MicrosoftTeams-image.png",
      description: `<h6>Integraciones</h6>
      <p>Integraciones SOA, Rest, BD, Servicio SSIS, WS Expuestos</p>
      <h6>Documentos</h6>
      <p>
        Generación y Manejo de documentos, Estación Digitalizadora, Envío de Mail, 
        SMS, Servicio ECM
      </p>
      <h6>Actividades Automáticas</h6>
      <p>Control de carga/tiempos, Servicios desatendidos</p>
      <h6>Motor de decisión SOA</h6>
      <p>Motor de Reglas SOA</p>
      <h6>Capacidad extendida en el Workflow</h6>
      <p>Líneas paralelas de proceso, Portal de clientes, Mobile</p>`,
      path: "/it-services",
      disableLink: true,
    },

  ],
}
